import { render, staticRenderFns } from "./Seguidores.vue?vue&type=template&id=0a6537d9"
import script from "./Seguidores.vue?vue&type=script&lang=js"
export * from "./Seguidores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports